<template>
    <div class="userInfo">
        <div class="userInfo-avatar flex justify-between align-center">
            <span>头像</span>

            <van-uploader :after-read="afterRead" :before-read="beforeRead" class="vanUploaderClass">
                <img class="userInfo-avatar-image" mode="aspectFill" :src="avatar" />
            </van-uploader>
        </div>

        <van-cell-group>
            <van-cell title="昵称" :value="userInfo.displayName" />
            <van-cell title="手机号" :value="userInfo.phoneNo" />
            <van-cell title="实名认证" is-link @click="toVerifyId">
                <template #default>
                    <div v-if="isCertification == 2">
                        <van-tag plain type="success" size="large">已认证</van-tag>
                        <span class="userInfo-verified-yes">{{ userInfo.userName }}</span>
                    </div>

                    <div v-if="isCertification == 1">
                        <van-tag plain type="warning" size="large">未认证</van-tag>
                        <span class="userInfo-verified-yes">{{ userInfo.userName }}</span>
                    </div>
                    <!-- <div v-if="isCertification == 2">
                        <van-tag plain type="warning" size="large">审核中</van-tag>
                        <span class="userInfo-verified-yes">{{ userInfo.userName }}</span>
                    </div>
                    <div v-if="isCertification == 3">
                        <van-tag plain type="danger" size="large">认证失败</van-tag>
                        <span class="userInfo-verified-yes">{{ userInfo.userName }}</span>
                    </div> -->
                </template>
            </van-cell>

            <van-cell title="性别" :value="userInfo.sex == 1 ? '男' : userInfo.sex == 2 ? '女' : '未知'" @click="sexPicker" is-link />
            <van-cell title="地区" :value="userInfo.fromCity" @click="cityPicker" is-link />

        </van-cell-group>
        <senselessPayment />
        <div style="height: 2vw">
        </div>

        <sexPicker :showSexPick.sync="showSexPick" @update="updateSex" />
        <cityPicker :showCityPick.sync="showCityPick" @update="updateCity" />

        <!-- <van-cell-group>
            <van-cell title="登录密码" @click="changePassword" is-link />
        </van-cell-group> -->
    </div>
</template>

<script>
import { getPersonalInfo, updatePersonalInfo, uploadImage, queryRealNameStatus } from "@/api/api";
import sexPicker from "@/components/picker/sexPicker.vue";
import cityPicker from "@/components/picker/cityPicker.vue";
import { beforeRead } from "@/libs/tools";
import senselessPayment from '@/components/senselessPayment'

export default {
    name: "UserInfo",
    components: {
        sexPicker,
        cityPicker,
        senselessPayment
    },
    data() {
        return {
            userInfo: {},
            showSexPick: false,
            showCityPick: false,
            isCertification: -1,
            backPicUrl: "",
            frontPicUrl: "",
        };
    },
    computed: {
        avatar() {
            return this.userInfo.headUrl ? this.userInfo.headUrl : require("@/assets/images/user/avatar-default.png");
        },
    },
    mounted() {
        this.getUserInfo();
    },

    methods: {
        beforeRead,
        // 获取用户信息

        async getUserInfo() {
            getPersonalInfo().then((res) => {
                this.userInfo = res.data;
            });
            queryRealNameStatus().then((res) => {
                this.isCertification = res.data.status;
                this.frontPicUrl = res.data.frontPicUrl;
                this.backPicUrl = res.data.backPicUrl;
            });
        },
        //跳转到验证码页面然后再跳转到身份证页面
        toVerifyId() {
            let obj = {
                isCertification: this.isCertification,
                frontPicUrl: this.frontPicUrl,
                backPicUrl: this.backPicUrl,
            };
            this.$router.push({ name: "verifyIdCard", query: obj });
        },
        //更换手机号
        changePhone() {
            this.$router.push("/mine/userinfo/changePhone");
        },
        //更换密码
        changePassword() {
            this.$router.push("/mine/userinfo/changePassword");
        },

        //选择性别
        sexPicker() {
            this.showSexPick = true;
        },
        //更新性别
        updateSex(sex) {
            let obj = {
                id: this.userInfo.id,
                sex: sex.value,
            };
            updatePersonalInfo(obj).then((res) => {
                if (res.code == 200) {
                    this.$toast("更新成功！");
                    this.getUserInfo();
                }
            });
        },
        //选择城市
        cityPicker() {
            this.showCityPick = true;
        },
        // 更新城市
        updateCity(city) {
            let str = city.reduce((pre, current) => {
                return (pre += current.name);
            }, "");
            let obj = {
                id: this.userInfo.id,
                fromCity: str,
            };
            updatePersonalInfo(obj).then((res) => {
                if (res.code == 200) {
                    this.$toast("更新成功！");
                    this.getUserInfo();
                }
            });
        },

        async afterRead(file) {
            let res = await uploadImage(file.file).then((res) => {
                return res;
            });
            let obj = {
                id: this.userInfo.id,
                headUrl: res.data.imgUrl,
            };
            updatePersonalInfo(obj).then((res) => {
                if (res.code == 200) {
                    this.$toast("更新成功！");
                    this.getUserInfo();
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
.userInfo {
    min-height: 100vh;
    background-color: #f5f8fa;
    padding-top: 16px;
    .userInfo-avatar {
        padding: 30px;
        background-color: #fff;
        .userInfo-avatar-image {
            width: 96px;
            height: 96px;

            border-radius: 50%;
            border: 4rpx solid #ffffff;
        }
    }
    .userInfo-verified-yes {
        margin-left: 10px;
    }
    .userInfo-verified-no {
        font-size: 28px;
        font-weight: 400;
        color: #f72d2d;
    }
}
</style>
